import { render } from "./Modalcompra.vue?vue&type=template&id=58a273f8&scoped=true"
import script from "./Modalcompra.vue?vue&type=script&lang=js"
export * from "./Modalcompra.vue?vue&type=script&lang=js"

import "./Modalcompra.vue?vue&type=style&index=0&id=58a273f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a273f8"]])

export default __exports__